export const API_URL = {
  mock: '',
  dev: '//newc-dev.apigw.qa.91jkys.com/api/',
  qa: '//newc-qa.apigw.qa.91jkys.com/api/',
  pre: 'https://apigw.pre.91jkys.com/api/',
  pro: 'https://apigw.91jkys.com/api/'
};

export const API_QR_CODE = {
  mock: '',
  dev: '//apigw.qa.91jkys.com/api/',
  qa: '//apigw.qa.91jkys.com/api/',
  pre: 'https://apigw.pre.91jkys.com/api/',
  pro: 'https://apigw.91jkys.com/api/'
};

export const STATIC_URL = {
  mock: 'http://static.qa.91jkys.com/',
  dev: '//static.qa.91jkys.com/',
  qa: '//static.qa.91jkys.com/',
  pre: 'https://static.pre.91jkys.com/',
  pro: 'https://static.91jkys.com/'
};

export const CALL_IOS_APP_DEEPLINK = {
  mock: 'https://deeplink.91jkys.com/zyhealthtest',
  dev: 'https://deeplink.91jkys.com/zyhealthtest',
  qa: 'https://deeplink.91jkys.com/zyhealthtest',
  pre: 'https://deeplink.91jkys.com/zyhealthpre',
  pro: 'https://deeplink.91jkys.com/zyhealth'
};

// 小程序
export const APPID = {
  mock: '',
  dev: 'wx3b43e675a19c5f64',
  qa: 'wx3b43e675a19c5f64',
  pre: 'wx219ddebecce94def',
  pro: 'wxb0a6a18d4e11abd1'
};

export const MINI_PROGRAM_ID = {
  mock: 'gh_bd901c85dcfb',
  dev: 'gh_bd901c85dcfb',
  qa: 'gh_bd901c85dcfb',
  pre: 'gh_3a1784477dc8',
  pro: 'gh_1c9f95bf95ce'
};

export const ANDROID_URL_SCHEME = 'zyhealth://zyhealth.com';
